/**
 * `/$org/apps/imanage/w/$workspaceId`: one workspace (client/matter), with the
 * open document, tab, search and sort in the query string.
 *
 * @module routes/$org.apps.imanage.w.$workspaceId
 */
import { createFileRoute } from "@tanstack/react-router";

import { parseIManageSearch } from "../components/apps/imanage/imanagePaths";
import { IManageWorkspaceView } from "../components/apps/imanage/IManageWorkspaceView";

function IManageWorkspaceRoute() {
  const { workspaceId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IManageWorkspaceView
      key={workspaceId}
      workspaceId={workspaceId}
      folderId={null}
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace ?? false })}
    />
  );
}

export const Route = createFileRoute("/$org/apps/imanage/w/$workspaceId")({
  validateSearch: parseIManageSearch,
  component: IManageWorkspaceRoute,
});
